export default __webpack_public_path__ + "static/media/prohibitedZone.4d8a2099.svg";